import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { GovcoAlertModalComponent } from '../../../../shared/govco/govco-alert-modal/govco-alert-modal.component';
import { GovcoConfirmModalComponent } from '../../../../shared/govco/govco-confirm-modal/govco-confirm-modal.component';
import { ProjectValidationService, ValidationDecision, ValidationProject } from '../../../../core/services/project-validation.service';

@Component({
  standalone: true,
  imports: [FormsModule, RouterLink, GovcoAlertModalComponent, GovcoConfirmModalComponent],
  templateUrl: './project-validation.component.html',
  styleUrl: './project-validation.component.css'
})
export class ProjectValidationComponent {
  readonly validation = inject(ProjectValidationService);
  selected?: ValidationProject;
  decision: ValidationDecision | '' = '';
  observation = '';
  attachmentName = '';
  managementOpen = false;
  cancelConfirmation = false;
  message = '';
  messageTitle = 'Éxito';
  messageVariant: 'warning' | 'success' | 'error' = 'success';
  lastResolved?: ValidationProject;
  get pending(): ValidationProject[] { return this.validation.pendingForCurrentAuthority(); }
  openManagement(project: ValidationProject): void { this.selected = project; this.decision = ''; this.observation = ''; this.attachmentName = ''; }
  requestSave(): void { if (!this.decision || !this.observation.trim()) { this.show('Advertencia', 'Seleccione una decisión y registre las observaciones obligatorias.', 'warning'); return; } this.managementOpen = true; }
  requestCancel(): void { this.cancelConfirmation = true; }
  cancelManagement(): void { this.cancelConfirmation = false; this.selected = undefined; }
  saveManagement(): void { if (!this.selected || !this.decision) return; const result = this.validation.resolve(this.selected.id, this.decision, this.observation.trim(), this.attachmentName || undefined); this.managementOpen = false; this.selected = undefined; if (!result) return; this.lastResolved = result; const consensusNote = result.authorities.length > 1 && result.status === 'En ajustes' ? ' Como hay decisiones no unánimes entre autoridades, el proyecto retorna a Registro en estado En ajustes.' : ''; this.show('Resultado de validación guardado', `Se notificará a ${result.registeredBy}. El proyecto quedó en estado ${result.status}.${consensusNote}`, 'success'); }
  private show(title: string, message: string, variant: 'warning' | 'success' | 'error'): void { this.messageTitle = title; this.message = message; this.messageVariant = variant; }
}
